import React from 'react';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import {Dialog, DialogTitle, Typography} from '@material-ui/core';
import {DialogActions, DialogContent, Button} from '@material-ui/core';
import Modal from 'Shared/components/Modal';

type JStampIssuePolicyConfirmationProps = {
  policyNumberL70: string[] | undefined;
  policyNumberAUE: string[] | undefined;
  handleClose: () => void;
  open: boolean;
  aueErrMsg: boolean;
  l70ErrMsg: boolean;
};

const JStampIssuePolicyConfirmation = (props: JStampIssuePolicyConfirmationProps) => {
  return (
    <Modal title="Error Detected" open={props.open} onClose={props.handleClose}>
      <div>
        <DialogContent>
          {props.aueErrMsg &&
            `WARNING: ${props.policyNumberAUE?.toString() +
              ' '}will not be issued by AppEntryGV: GAUE Errors exist on the policy. The Policy was
          successfully saved to life 70 as a pending policy for viewing in AppEntryQ.`}
          {props.l70ErrMsg &&
            `WARNING: ${props.policyNumberL70?.toString() +
              ' '}will not be issued by AppEntryGV: Severity 2 or Severity 3 messages exist on the policy. The Policy was
          successfully saved to life 70 as a pending policy for viewing in AppEntryQ.`}
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Cancel</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};
export default JStampIssuePolicyConfirmation;
